import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum ScanGovernmentIdStep {
  Scan = 'Scan',
  Success = 'Success',
  Fail = 'Fail',
  Bypass = 'Bypass',
}

// The BPMN also routes a no-result default edge to ReportToReceptionProcess, but
// WorkflowVariables always carries a concrete isScanGovernmentIdSuccess boolean, so
// that edge can never be reached through this engine.
export const scanGovernmentIdFlow: CheckinWorkflow<ScanGovernmentIdStep> = {
  id: FlowId.ScanGovernmentId,
  entry: ScanGovernmentIdStep.Scan,
  steps: {
    [ScanGovernmentIdStep.Scan]: {
      id: ScanGovernmentIdStep.Scan,
      page: PageKey.SCAN_GOVERNMENT_ID,
      next: (variables) => ({
        nextStep: variables.isScanGovernmentIdSuccess
          ? ScanGovernmentIdStep.Success
          : ScanGovernmentIdStep.Fail,
      }),
    },
    [ScanGovernmentIdStep.Success]: {
      id: ScanGovernmentIdStep.Success,
      page: PageKey.SCAN_GOVERNMENT_ID_SUCCESS,
      next: () => ({ complete: true }),
    },
    [ScanGovernmentIdStep.Fail]: {
      id: ScanGovernmentIdStep.Fail,
      page: PageKey.SCAN_GOVERNMENT_ID_FAIL,
      next: () => ({ nextStep: ScanGovernmentIdStep.Scan }),
      back: () => ({ nextStep: ScanGovernmentIdStep.Scan }),
      bypass: () => ({ nextStep: ScanGovernmentIdStep.Bypass }),
    },
    [ScanGovernmentIdStep.Bypass]: {
      id: ScanGovernmentIdStep.Bypass,
      page: PageKey.BYPASS,
      next: () => ({ complete: true }),
      back: () => ({ nextStep: ScanGovernmentIdStep.Scan }),
    },
  },
};
